export function hasConsent(activeGroups: string | undefined, groupId: string): boolean {
    if (!activeGroups) return false;

    return activeGroups
        .split(',')
        .map((group) => group.trim())
        .includes(groupId);
}
